<div class="terms-of-use">

    <!-- <div class="section-title" *ngIf="showHeader">
        <h4>Terms of Use</h4>        
        <span class="text-xl font-bold terms-of-use" translate> Acceptance of the Terms of Use</span>
    </div> -->

    <div class="container">
        <div [innerHTML]="textDirection == 'rtl' ? sanitizerContent(content?.contentEn) : sanitizerContent(content?.contentAr)"></div>
    </div>
    

</div>